import Api from "../axios";

export default async function apiManagersList() {
  return await Api.get("/manager_list");
}
